import { useEffect, useState } from 'react';
import { BrowserRouter as Router,
    Routes,
    Route,
    Link } from "react-router-dom";

// === COMPONENTS
import C from "../photos/C-Cause.svg";
import A from "../photos/A-Cause.svg";
import U from "../photos/U-Cause.svg";
import S from "../photos/S-Cause.svg";
import E from "../photos/E-Cause.svg";
import LAB from "../photos/LAB.png";
import useFetch from '../useFetch';
import SEO from '../components/seo';

    function CaseStudyList() {
        const { isLoading, error, data } = useFetch(`${process.env.REACT_APP_BACKEND}/api/case-study-list?populate=deep`)
        const [currentProject, setCurrentProject] = useState('none')

        let caseStudies = []
        let archive = []

        const imageToggleOn = (id) => {
            document.getElementById('image-bckground').classList.remove("fadeOut")
            document.getElementById('image-bckground').classList.add("fadeIn")
            setCurrentProject(id)
        }

        const imageToggleOff = () => {
            document.getElementById('image-bckground').classList.remove("fadeIn")
            document.getElementById('image-bckground').style.opacity = 1;
            document.getElementById('image-bckground').classList.add("fadeOut")
        }

        if (data) {
            
            caseStudies = data.data.attributes.case_studies.data
            archive = caseStudies.slice(5)

            console.log (`featured`, caseStudies)
            console.log (`archive`, archive)

            return (
                <div className="main-content-wrapper-work-list">
                    <SEO title="Our Work | CauseLab" />
                    {/* <div className="image-handler" style={{backgroundImage: `url(${ currentProject })`}}> */}
                    <div className="image-handler">
                        <img className="image-handler-background" id="image-bckground" src={ currentProject } />
                        <h2>Our Work</h2>
                    </div>
                    <div className='flex-center'>
                        <div className="case-study-list-container" >
                            <img className="grid-element fadeIn" src={ C } />
                            { caseStudies[0] ? (
                                <a 
                                    href={`/our-work/${caseStudies[0].attributes.slug}`}
                                    onMouseEnter={() => imageToggleOn(`${caseStudies[0].attributes.Feature_Image.data.attributes.url}`)}
                                    onMouseLeave={() => imageToggleOff()}
                                    className="grid-element">
                                    <h2>{caseStudies[0].attributes.Project_Title}</h2>
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </a>
                            ) : (
                                <div className="grid-element">
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </div>
                                ) 
                            }
                            { caseStudies[1] ? (
                                <a 
                                    href={`/our-work/${caseStudies[1].attributes.slug}`}
                                    onMouseEnter={() => imageToggleOn(`${caseStudies[1].attributes.Feature_Image.data.attributes.url}`)}
                                    onMouseLeave={() => imageToggleOff()}
                                    className="grid-element">
                                    <h2>{caseStudies[1].attributes.Project_Title}</h2>
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </a>
                            ) : (
                                <div className="grid-element">
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </div>
                                ) 
                            }
                            <img className="grid-element" src={ A } />
                            <img className="grid-element" src={ U } />
                            { caseStudies[2] ? (
                                <a 
                                    href={`/our-work/${caseStudies[2].attributes.slug}`}
                                    onMouseEnter={() => imageToggleOn(`${caseStudies[2].attributes.Feature_Image.data.attributes.url}`)}
                                    onMouseLeave={() => imageToggleOff()}
                                    className="grid-element">
                                    <h2>{caseStudies[2].attributes.Project_Title}</h2>
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </a>
                            ) : (
                                <div className="grid-element">
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </div>
                                ) 
                            }
                            <img className="grid-element" src={ S } />
                            { caseStudies[3] ? (
                                <a 
                                    href={`/our-work/${caseStudies[3].attributes.slug}`}
                                    onMouseEnter={() => imageToggleOn(`${caseStudies[3].attributes.Feature_Image.data.attributes.url}`)}
                                    onMouseLeave={() => imageToggleOff()}
                                    className="grid-element">
                                    <h2>{caseStudies[3].attributes.Project_Title}</h2>
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </a>
                            ) : (
                                <div className="grid-element">
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </div>
                                ) 
                            }
                            { caseStudies[4] ? (
                                <a 
                                    href={`/our-work/${caseStudies[4].attributes.slug}`}
                                    onMouseEnter={() => imageToggleOn(`${caseStudies[4].attributes.Feature_Image.data.attributes.url}`)}
                                    onMouseLeave={() => imageToggleOff()}
                                    className="grid-element">
                                    <h2>{caseStudies[4].attributes.Project_Title}</h2>
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </a>
                            ) : (
                                <div className="grid-element">
                                    <svg className="grid-hex" xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 465 466">
                                        <path d="M464.965 424.719V245.645L465 245.68L464.965 41.2813L423.775 0L41.1896 0L0 41.2813L0 424.719L41.1896 466H423.775L464.965 424.719Z"/>
                                    </svg>
                                </div>
                                ) 
                            }
                            <img className="grid-element" src={ E } />
                            
                        </div>
                        <div className='lab-block'>
                            <img className="lab" src={ LAB } />
                        </div>
                        <div className="case-study-list-bottom">
                            <div style={{backgroundImage: `linear-gradient(225deg, rgba(229, 82, 28, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="bl-tr-diagonal-large"></div>
                            <div className="hexagon-middle-primary-large"></div>
                            <div style={{backgroundImage: `linear-gradient(135deg, rgba(229, 82, 28, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="tl-br-diagonal-large"></div>
                        </div>
                        <div className="archive-list-container">
                            <h1>In the Archive</h1>
                            <div className='archive-header'>
                                <h4>Project</h4>
                                <h4>Client</h4>
                                <h4>Tag</h4>
                            </div>
                            <svg className="list-intro-line" viewBox="0 0 1336 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_278_556)">
                                <mask id="path-1-inside-1_278_556" fill="white">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1352 748V506.5V241.5V-5.09131e-05L187.244 -0.000111948L40.6663 -5.09131e-05L-5.99998 44.8656L-6 286.404V461.596L-5.99998 703.134L40.6663 748L187.244 748L1352 748Z"/>
                                </mask>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1352 748V506.5V241.5V-5.09131e-05L187.244 -0.000111948L40.6663 -5.09131e-05L-5.99998 44.8656L-6 286.404V461.596L-5.99998 703.134L40.6663 748L187.244 748L1352 748Z" fill="#FEFEE4"/>
                                <path d="M1352 748H1357V753L1352 753L1352 748ZM1352 -5.09131e-05L1352 -5.00005L1357 -5.00005V-5.09131e-05H1352ZM187.244 -0.000111948L187.244 -5.00011L187.244 -5.00011L187.244 -0.000111948ZM40.6663 -5.09131e-05L37.201 -3.60444L38.6526 -5.00005L40.6663 -5.00005L40.6663 -5.09131e-05ZM-5.99998 44.8656L-11 44.8656L-11 42.7367L-9.46529 41.2612L-5.99998 44.8656ZM-6 286.404L-11 286.404L-11 286.404L-6 286.404ZM-6 461.596L-11 461.596V461.596H-6ZM-5.99998 703.134L-9.4653 706.739L-11 705.263L-11 703.134L-5.99998 703.134ZM40.6663 748L40.6663 753L38.6526 753L37.201 751.604L40.6663 748ZM187.244 748L187.244 753L187.244 753L187.244 748ZM1357 506.5V748H1347V506.5H1357ZM1347 506.5V241.5H1357V506.5H1347ZM1347 241.5V-5.09131e-05H1357V241.5H1347ZM1352 4.99995L187.244 4.99989L187.244 -5.00011L1352 -5.00005L1352 4.99995ZM187.244 4.99989L40.6663 4.99995L40.6663 -5.00005L187.244 -5.00011L187.244 4.99989ZM44.1316 3.60434L-2.53467 48.47L-9.46529 41.2612L37.201 -3.60444L44.1316 3.60434ZM-0.999982 44.8656L-1 286.404L-11 286.404L-11 44.8656L-0.999982 44.8656ZM-11 461.596V286.404H-1V461.596H-11ZM-11 703.134L-11 461.596L-1 461.596L-0.999982 703.134L-11 703.134ZM37.201 751.604L-9.4653 706.739L-2.53467 699.53L44.1316 744.396L37.201 751.604ZM187.244 753L40.6663 753L40.6663 743L187.244 743L187.244 753ZM1352 753L187.244 753L187.244 743L1352 743L1352 753Z" fill="#E5521C" mask="url(#path-1-inside-1_278_556)"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_278_556">
                                <rect width="1336" height="46" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            
                            {archive.map((entry, index) => 
                                <a className='no-underline' href={`/our-work/${entry.attributes.slug}`}>
                                    <div className='archive-entry-wrapper' id={index} key={ index }>
                                        <h4 className="bold">{ entry.attributes.Project_Title }</h4>
                                        <h4>{ entry.attributes.Client }</h4>
                                        <h4>{ entry.attributes.Cause }</h4>
                                    </div>
                                </a>
                            )}
                        </div>
                    </div>
                    
                </div>
            );
        }
    }
    
    export default CaseStudyList;